import React from 'react';
import {Button, ButtonGroup, FormControl, MenuItem, OutlinedInput, Select,} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles'
import {BackArrowIcon, ForwardArrowIcon} from "../../../helpers/Icons";

const styles = {
  paginationContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap:'0.5rem',
    marginLeft:'auto',
  },
  // paginationGroup: {
  //   display: 'flex',
  //   flexDirection: 'row',
  //   flexWrap: 'wrap',
  //   gap:'0.5em',
  //   padding: '0em',
  //   alignItems: 'center',
  //   flexGrow:1,
  //   justifyContent:'space-between'
  // },
  pageLabel: {
    flexShrink: 1,
    fontSize: '0.7225rem',
    fontWeight: 500,
    color: 'rgba(0,0,0,0.7225)',
    // minWidth: '7.5em',
    whiteSpace:'nowrap',
    textAlign:'center'
  },
  pageControl: {
    marginRight: '0em',
    '& ul':{
      gap:'0.15em 0',
    },
    '& > button':{
      backgroundColor: '#fff',
      borderRadius:'0px',
      margin:'0px',
      marginLeft:'-1px',
      width: '28px',
      minWidth: '28px',
      height: '28px'
    },
    '& > button:first-child':{
      borderRadius:'4px 0 0 4px',
      margin:'0px'
    },
    '& > button:last-child':{
      borderRadius:'0 4px 4px 0',
      borderWidth:'1px'
    }
  },
  root:{
    flexDirection:'row',
    flexWrap:'wrap'
  },
  select:{
    boxSizing: 'content-box',
    lineHeight: '8px',
    // padding: '4px 0 0 0',
    // overflow:'hidden',
    fontSize: '0.85rem',
    fontWeight: 400,
    '& > div:first-child':{
      backgroundColor: '#fff',
      paddingLeft: '0.5rem',
      paddingRight: '1.25rem',
      overflow:'hidden',
      borderRadius:'4px 0 0 4px',
      boxSizing:'border-box',
      // minWidth:'5rem',
      height:'28px',
      textAlign: 'right'
    },
    '& > svg':{
      right:0,
    },
  },
  arrow:{
    fontSize:'20px'
  }
};

function DataPaginationSmall(props) {
  const {controller, itemsTotal, pageItemCount, handlePageChange, handleChangeRowsPerPage, classes} = props;

  const itemFirst = Math.max(0, ((controller.page - 1) * controller.rowsPerPage) + 1);
  const itemLast = Math.min(itemFirst + pageItemCount - 1, controller.page * controller.rowsPerPage );

  const pagePrev = (e) => {
    if(controller.page <= 1){
      return
    }
    handlePageChange(e, controller.page - 1);
  }
  const pageNext = (e) => {
    if(!!itemsTotal && controller.page >= Math.ceil(itemsTotal/controller.rowsPerPage)){
      return;
    }
    handlePageChange(e, controller.page + 1);
  }

  return (
    <div className={classes.paginationContainer}>
      <span className={classes.pageLabel}>
        {itemsTotal === 0 || !itemsTotal || !itemFirst ?
          <><span id="pageCountTop">{itemFirst}-{itemLast}</span><br/></> :
          <><span id="pageCountTop">{itemFirst}-{itemLast}</span><br/>of <span id="dataTotalTop">{itemsTotal}</span></>
        }
      </span>
      <FormControl
        className={classes.root}
        variant="outlined"
      >
        <Select
          id="pageSizeTop"
          className={classes.select}
          value={controller.rowsPerPage}
          onChange={handleChangeRowsPerPage}
          input={
            <OutlinedInput
              margin='dense'
            />}
        >
          {[2,12,24,60,96,120].map((size) => (
            <MenuItem key={size} value={size}>{size}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <ButtonGroup
        className={classes.pageControl}>
        <Button variant="outlined"
          id="previousPageTop"
          disabled={controller.page <= 1}
          className={classes.toolbarButton}
          onClick={pagePrev}
        >
          <BackArrowIcon style={{fontSize:'20px'}} />
        </Button>
        <Button variant="outlined"
          id="nextPageTop"
          disabled={(!!itemsTotal && controller.page >= Math.ceil(itemsTotal/controller.rowsPerPage)) || (!itemsTotal && pageItemCount < controller.rowsPerPage)}
          className={classes.toolbarButton}
          onClick={pageNext}
        >
          <ForwardArrowIcon style={{fontSize:'20px'}} />
        </Button>
      </ButtonGroup>
    </div>
  );
}

export default withStyles(styles)(DataPaginationSmall)
